import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toggleSidebar } from '../../redux/slices/uiSlice';

export function useLayout() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const dispatch = useDispatch();
  
  const toggleMobileMenu = useCallback(() => {
    dispatch(toggleSidebar());
  }, [dispatch]);
  
  const handleResize = useCallback(() => {
    const mobile = window.innerWidth <= 992;
    setIsMobile(mobile);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return {
    isMobile,
    toggleMobileMenu
  };
}